module.exports = __webpack_public_path__ + "1ab20c37c34ac4ba3978430efab8bdee.pdf";